/**
 * Module: lib/copilot/toolCopy
 * Responsibility: Maps merchant-MCP tool names to d2c-friendly copy for the
 * ThinkingIndicator and CombinedToolUseCard. Unknown tools get a generic fallback.
 */

export interface ToolCopy {
  readonly running: string
  readonly done: (resultCount: number) => string
}

const COPY_MAP: Readonly<Record<string, ToolCopy>> = {
  shopflo_product_list: { running: 'Fetching products...', done: n => `Found ${n} products` },
  shopflo_variant_list: { running: 'Loading product variants...', done: n => `Loaded ${n} variants` },
  shopflo_collection_list: { running: 'Loading collections...', done: n => `Loaded ${n} collections` },
  shopflo_coupon_list: { running: 'Reading coupons...', done: n => `Read ${n} coupons` },
  shopflo_coupon_create: { running: 'Creating coupon...', done: () => 'Coupon created' },
  shopflo_upsell_list: { running: 'Loading upsells...', done: n => `Loaded ${n} upsells` },
  shopflo_sales_funnel_analysis: { running: 'Analysing your funnel...', done: () => 'Funnel analysis ready' },
  shopflo_order_list: { running: 'Loading orders...', done: n => `Loaded ${n} orders` },
  shopflo_segment_list: { running: 'Loading segments...', done: n => `Loaded ${n} segments` },
  shopflo_delivery_profile_list: {
    running: 'Loading delivery profiles...',
    done: n => `Loaded ${n} delivery profiles`
  },
  shopflo_shipping_zone_list: {
    running: 'Loading shipping zones...',
    done: n => `Loaded ${n} shipping zones`
  }
}

export function resolveToolCopy(toolName: string): ToolCopy {
  const entry = COPY_MAP[toolName]
  if (entry) return entry
  return {
    running: `Running ${toolName}...`,
    done: n => `${toolName} returned ${n} results`
  }
}
